export class DateHelper {
  /**
   * Retorna la fecha al inicio del día (con -1 ms) en formato ISO.
   * Útil para incluir registros exactamente a las 00:00:00.
   */
  static getStartOfDay(date?: Date | string): string | null {
    if (!date) return null;
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return new Date(d.getTime() - 1).toISOString();
  }

  /**
   * Retorna la fecha al final del día (con +1 ms) en formato ISO.
   * Útil para incluir registros hasta las 23:59:59.999.
   */
  static getEndOfDay(date?: Date | string): string | null {
    if (!date) return null;
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return new Date(d.getTime() + 1).toISOString();
  }
}
